import { React, useState } from 'react';
import '../../App.css'
import { Grid, Box, Button, Paper, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography, CircularProgress } from '@mui/material';
import { RequestQuote } from '@mui/icons-material';
import * as monthList from '../../services/monthList';
import * as yearList from '../../services/yearList';
import Popup from '../Popup';
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Notification from '../Notification';
import { setLoaderMessage } from '../../utils/loaderManager';

// Custom component for required field label
const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

const monthOptions = monthList.getMonthList();
const yearOptions = yearList.getYearList();

const today = new Date();
const currentYear = today.getFullYear().toString();
const currentMonthIndex = today.getMonth();
const currentMonthName = monthOptions[currentMonthIndex].title;

const initialFValues = {
  id: 0,
  month: currentMonthName,
  year: currentYear,
}

function IncomeTaxReport() {

  const [empDetails, setEmpDetails] = useState([]);
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    let temp = {}
    temp.month = values.month ? "" : "This field is required."
    temp.year = values.year ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  function handleInputChange(e) {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  }

  const handleDisplayClick = (e) => {
    e.preventDefault();

    if (validate()) {
      setLoading(true);
      setLoaderMessage('Generating income tax report...');

      const payload = {
        financial_year: `${values.year}-${Number(values.year) + 1}`,
        current_month: values.month
      };

      axios.post(`${process.env.REACT_APP_API_BASE_URL}/report/get-emp-month-tax-report`, payload)
        .then((response) => {
          setEmpDetails(response.data);
          // Navigate to results page with data
          navigate('/income-tax-report-results', { state: { empDetails: response.data, year: values.year } });
        })
        .catch((error) => {
          const status = error.response ? error.response.status : null;
          if (status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              window.location.href = '/';
            }, 1000);
          } else {
            setNotify({
              isOpen: true,
              message: 'An error occurred while fetching the report.',
              type: 'error'
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", padding: "30px", fontWeight: "500px" }}>
      <Paper elevation={0} sx={{ width: "1000px", height: "210px" }}>
        <Grid className="form-title" container spacing={2} justifyContent="center" style={{ marginTop: "15px" }} alignItems="center">
          <Grid item> <HiOutlineCurrencyRupee size={30} sx={{ width: 45, height: 45 }} /> </Grid>
          <Grid item> <Typography variant="h5">Income Tax Report</Typography> </Grid>
        </Grid>

        <form className="classes.root" autoComplete="off" onSubmit={(e) => e.preventDefault()}>

          <Box sx={{ margin: "30px" }}>
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              flexWrap: 'wrap'
            }}>

              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.month && { error: true })}
              >
                <InputLabel><RequiredLabel label="Month" /></InputLabel>
                <Select
                  label="Month"
                  name="month"
                  size="small"
                  value={values.month}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {
                    monthOptions.map(
                      item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                    )
                  }
                </Select>
                {errors.month && <FormHelperText>{errors.month}</FormHelperText>}
              </FormControl>

              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.year && { error: true })}
              >
                <InputLabel><RequiredLabel label="Year" /></InputLabel>
                <Select
                  label="Year"
                  name="year"
                  size="small"
                  value={values.year}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {
                    yearOptions.map(
                      item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                    )
                  }
                </Select>
                {errors.year && <FormHelperText>{errors.year}</FormHelperText>}
              </FormControl>

              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                  style={{ height: 40 }}
                  variant="outlined"
                  color="secondary"
                  onClick={handleDisplayClick}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} color="secondary" />
                  ) : (
                    'Display'
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        </form>

        {/* Results are shown on the generated results page */}

      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify}
      />
    </Box>
  )
}

export default IncomeTaxReport;


